import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { copyToClipboard } from '@sbercloud/ft-copy-to-clipboard';
import { DEFAULT_BACKEND_HOST, DEFAULT_BASE_URL, DEFAULT_HEADERS } from './constants';
var CALCULATOR_SHARE_SAVE_URL = '/calculator-share/v2/save';

/**
 *
 * Функция для получения ссылки на расчет
 * @function helper
 */
function getShareSaveService(backendHost) {
  return /*#__PURE__*/function () {
    var _shareSaveService = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(state) {
      var totalUrl, body, params, res, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            totalUrl = backendHost + CALCULATOR_SHARE_SAVE_URL;
            body = {
              calculatorType: state.calculatorType,
              products: state.products
            };
            params = {
              method: 'POST',
              headers: DEFAULT_HEADERS,
              body: JSON.stringify(body)
            };
            _context.next = 5;
            return fetch(totalUrl, params);
          case 5:
            res = _context.sent;
            if (res.ok) {
              _context.next = 8;
              break;
            }
            throw new Error("fetcher");
          case 8:
            _context.next = 10;
            return res.json();
          case 10:
            response = _context.sent;
            if (response.data) {
              _context.next = 13;
              break;
            }
            throw new Error("fetcher");
          case 13:
            return _context.abrupt("return", response.data);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function shareSaveService(_x) {
      return _shareSaveService.apply(this, arguments);
    }
    return shareSaveService;
  }();
}
export function getOnShareClick() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$backendHost = props.backendHost,
    backendHost = _props$backendHost === void 0 ? DEFAULT_BACKEND_HOST : _props$backendHost,
    _props$baseUrl = props.baseUrl,
    baseUrl = _props$baseUrl === void 0 ? DEFAULT_BASE_URL : _props$baseUrl;
  var shareSaveService = getShareSaveService(backendHost);
  return /*#__PURE__*/function () {
    var _onShareClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(state) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", shareSaveService(state).then(function (_ref) {
              var hash = _ref.Hash;
              var shareLink = "".concat(baseUrl, "/calculator?hash=").concat(hash);
              shareLink && copyToClipboard(shareLink);
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function onShareClick(_x2) {
      return _onShareClick.apply(this, arguments);
    }
    return onShareClick;
  }();
}